export default [
  '',
  'Petit Formal Script',
  'Raleway',
  'MADE Mirage',
  'Alegreya',
  'Parisienne',
  'Ysabeau SC',
  'Great Vibes',
  'Lexend Deca',
  'Cormorant Garamond',
  'Ms Madi',
  'Gilda Display',
];
